// src/palettes/neonPalettes.js
const neonPalettes = [
  { name: 'Cyberpunk', colors: ['#FF00FF', '#00FFFF', '#FF3399', '#33FFFF', '#CC00CC'] },
  { name: 'Electric Blue', colors: ['#00FF00', '#00FFFF', '#33FF33', '#33FFFF', '#00CC00'] },
  { name: 'Hot Pink', colors: ['#FF1493', '#FF69B4', '#FFB6C1', '#FFC0CB', '#CC1077'] },
  { name: 'Laser Lemon', colors: ['#FFFF00', '#FFFF66', '#FFFF99', '#FFFFCC', '#CCCC00'] },
  { name: 'Neon Green', colors: ['#39FF14', '#4CFF31', '#5FFF47', '#73FF5F', '#8AFF77'] },
  { name: 'Neon Orange', colors: ['#FF5F1F', '#FF6B2F', '#FF7A3F', '#FF8A4F', '#FF9A5F'] },
  { name: 'Neon Purple', colors: ['#BF00FF', '#C700FF', '#D100FF', '#DA1FFF', '#E41FFF'] },
  { name: 'Neon Magenta', colors: ['#FF00FF', '#FF33FF', '#FF66FF', '#FF99FF', '#FFCCFF'] },
  { name: 'Neon Cyan', colors: ['#00FFFF', '#33FFFF', '#66FFFF', '#99FFFF', '#CCFFFF'] },
  { name: 'Bright Neon', colors: ['#FF007F', '#FF3380', '#FF6680', '#FF9980', '#FFCC80'] },
  { name: 'Futuristic Neon', colors: ['#00FF7F', '#00CC66', '#00994D', '#006633', '#003300'] },
  { name: 'Vibrant Neon', colors: ['#FF00AA', '#FF33BB', '#FF66CC', '#FF99DD', '#FFCCEE'] },
  { name: 'Urban Neon', colors: ['#00CCFF', '#33D1FF', '#66D5FF', '#99D9FF', '#CCDDF0'] },
  { name: 'Glowing Red', colors: ['#FF2400', '#FF4500', '#FF6347', '#FF7F50', '#FF8C69'] },
  { name: 'Neon Spectrum', colors: ['#FF0000', '#FF7F00', '#FFFF00', '#00FF00', '#0000FF'] },
  { name: 'Neon Fusion', colors: ['#FF0099', '#FF3366', '#FF6633', '#FF9966', '#FFCC33'] },
  { name: 'Digital Dream', colors: ['#FF00FF', '#FF4CFF', '#FF99FF', '#FFCCFF', '#FF33FF'] },
  { name: 'Neon Pulse', colors: ['#00FF00', '#00FF33', '#00FF66', '#00FF99', '#00FFCC'] },
  { name: 'Neon Blaze', colors: ['#FF4500', '#FF5E00', '#FF7700', '#FF9000', '#FFA900'] },
  { name: 'Neon Wave', colors: ['#00BFFF', '#00E5FF', '#00FFFF', '#00F0FF', '#00D0FF'] },
  { name: 'Neon Flux', colors: ['#AA00FF', '#B300FF', '#C000FF', '#CD00FF', '#DA00FF'] },
  { name: 'Neon Mirage', colors: ['#FF3366', '#FF4477', '#FF5588', '#FF6699', '#FF77AA'] },
  { name: 'Neon Shock', colors: ['#FF3366', '#FF6633', '#FF9933', '#FFCC33', '#FF3300'] },
  { name: 'Neon Orbit', colors: ['#33FFCC', '#33FFDD', '#33FFEE', '#33FFFF', '#33CCFF'] },
  { name: 'Neon Vibe', colors: ['#00FF99', '#33FFAA', '#66FFBB', '#99FFCC', '#CCFFDD'] },
  { name: 'Neon Radiance', colors: ['#FF0044', '#FF3366', '#FF6688', '#FF99AA', '#FFCCBB'] },
  { name: 'Neon Spectrum II', colors: ['#FF0000', '#FF5500', '#FFAA00', '#AAFF00', '#00FF55'] },
  { name: 'Neon Burst', colors: ['#FF0099', '#FF3399', '#FF6699', '#FF9999', '#FFCC99'] },
  { name: 'Neon Flare', colors: ['#FF33CC', '#FF44CC', '#FF55CC', '#FF66CC', '#FF77CC'] },
  { name: 'Neon Glimmer', colors: ['#FF0033', '#FF1144', '#FF2255', '#FF3366', '#FF4477'] },
  { name: 'Neon Edge', colors: ['#CCFF33', '#BBFF33', '#AAFF33', '#99FF33', '#88FF33'] },
  { name: 'Neon Infinity', colors: ['#9900FF', '#AA00FF', '#BB00FF', '#CC00FF', '#DD00FF'] },
];

export default neonPalettes;
